import React from 'react';
import cn from 'clsx';

import Typography from '../../library/typography/typography';

import styles from './static-quantity.scss';

interface StaticQuantityProps {
  className?: string;
  isHorizontal?: boolean;
  quantity: number;
  variant?: string;
}

function StaticQuantity(props: StaticQuantityProps) {
  const {
    className = '',
    isHorizontal = false,
    quantity,
    variant = 'P'
  } = props;

  if (isNaN(quantity)) {
    return null;
  }

  if (isHorizontal) {
    return (
      <Typography
        className={cn(
          styles['horizontal-container'],
          `static-quantity ${className}`
        )}
        tag="span"
        variant={variant}
      >
        <span>QTY</span> &nbsp;&nbsp;{quantity}
      </Typography>
    );
  }

  return (
    <Typography
      className={cn(styles['container'], `static-quantity ${className}`)}
      tag="div"
    >
      <span className={cn(styles['quantity-label'], 'static-quantity__label')}>
        qty
      </span>
      <span className={cn(styles['quantity-value'], 'static-quantity__value')}>
        {quantity}
      </span>
    </Typography>
  );
}

export default StaticQuantity;
